import { setDefaults as o } from "./help-center-knowledge-anatomies43.js";
import { setI18n as r } from "./help-center-knowledge-anatomies42.js";
const p = {
  type: "3rdParty",
  init(t) {
    o(t.options.react), r(t);
  }
};
export {
  p as initReactI18next
};
//# sourceMappingURL=help-center-knowledge-anatomies12.js.map
